import SegmentControl from "Components/Sales/SegmentControl";
import useQueryParams from "utils/useQueryParams";
import "Styles/pages/analytics/paymentMix.css";
export function PaymentMixCard({ mix, days, channel }) {
  const {searchParams, updateQueryParams} = useQueryParams();
  const type = searchParams.get("payment") === "agency" ? "agency" : "self";
  const current = mix[type];
  return (
    <section
      className="a2-panel a2-payment-mix"
      aria-labelledby="payment-mix-title"
    >
      <div className="a2-panel-head">
        <div>
          <h2 id="payment-mix-title">어떤 출원에 결제했나요?</h2>
          <p>
            {channel === "all" ? "전체 유입 경로" : channel} · 가입 후 {days}일
          </p>
        </div>
      </div>
      <SegmentControl
        aria-label="결제 출원 유형"
        compact
        options={[
          { key: "self", label: `셀프출원 ${mix.self.buyers}명` },
          { key: "agency", label: `등록대행 ${mix.agency.buyers}명` },
        ]}
        value={type}
        onChange={payment => updateQueryParams({payment})}
      />
      <div className="a2-payment-total">
        <span>
          {type === "self" ? "셀프출원" : "등록대행"} 결제 {current.orders}건
        </span>
        <b>₩{current.gross_paid_amount.toLocaleString("ko-KR")}</b>
      </div>
      <div className="a2-payment-labels">
        <span>결제 항목</span>
        <span>회원 · 유형 내 비중</span>
      </div>
      <div className="a2-payment-lists">
      {Object.entries(mix).map(([key, group]) => (
      <ul className="a2-payment-rows" key={key} aria-hidden={type !== key}>
        {group.items.map((r) => (
          <li key={r.item_id}>
            <div>
              <span>{r.label}</span>
              <span>
                <b>{r.buyers}명</b>
                <small>
                  {r.buyer_share === null ? "—" : r.buyer_share.toFixed(1) + "%"}
                </small>
              </span>
            </div>
            <div className="a2-state-track" aria-hidden="true">
              <i style={{ width: (r.buyer_share ?? 0) + "%" }} />
            </div>
          </li>
        ))}
      </ul>
      ))}
      </div>
        <p className="a2-small a2-payment-empty" aria-hidden={Boolean(current.buyers)}>
          선택 조건의 {type === "self" ? "셀프출원" : "등록대행"} 결제 기록이 없습니다.
        </p>
      <p className="a2-small a2-payment-note">
        비중 = 항목 결제 회원 ÷ 해당 유형 결제 회원.
        <br />
        여러 항목·유형 결제 시 중복 포함
      </p>
    </section>
  );
}
